import { render } from "./Setting.vue?vue&type=template&id=f29285f4"
import script from "./Setting.vue?vue&type=script&setup=true&lang=js"
export * from "./Setting.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Setting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f29285f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f29285f4', __exports__)) {
    api.reload('f29285f4', __exports__)
  }
  
  module.hot.accept("./Setting.vue?vue&type=template&id=f29285f4", () => {
    api.rerender('f29285f4', render)
  })

}


export default __exports__